<template>
  <div
    class="product-detail-images"
  >
    <div
      ref="scrollRef"
      class="product-detail-images__content"
    >
      <Image
        class="product-detail-images__image"
        v-for="(image, index) of images"
        :key="index"
        :src="image"
        @click="open('description', index)"
      />
    </div>
    <div
      class="product-detail-images__navigation product-detail-images__navigation--left"
      @click="onPrev"
    >
      <Icon name="icon-arrow-left-l" />
    </div>
    <div
      class="product-detail-images__navigation product-detail-images__navigation--right"
      @click="onNext"
    >
      <Icon name="arrow-right-l-2" />
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { Image } from '@/components/Image'
import { useTemplateRef } from 'vue'
import { useImagePreview } from './OfferImagePreview'

defineProps({
  images: {
    type: Array,
    required: true
  }
})

const { open } = useImagePreview()

const scrollRef = useTemplateRef('scrollRef')

const onPrev = () => {
  if (!scrollRef.value) return
  scrollRef.value.scrollTo({
    left: scrollRef.value.scrollLeft - 280,
    behavior: 'smooth'
  })
}

const onNext = () => {
  if (!scrollRef.value) return
  scrollRef.value.scrollTo({
    left: scrollRef.value.scrollLeft + 280,
    behavior: 'smooth'
  })
}
</script>

<style lang="less" scoped>
.product-detail-images {
  position: relative;

  &__content {
    display: flex;
    gap: 12px;
    padding-bottom: 30px;
    width: 100%;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      /* 隐藏默认的滚动条 */
      -webkit-appearance: none;
    }

    &::-webkit-scrollbar{
      height: 8px;
    }
    &::-webkit-scrollbar-thumb{
      border-radius: 1em;
      background-color: #EBEBEB;
    }

    &::-webkit-scrollbar-track{
      border-radius: 1em;
      background-color: #F8F8F8;
    }
  }

  &__image {
    flex-shrink: 0;
    width: 256px;
    border-radius: 8px;
    aspect-ratio: 1;
    scroll-snap-align: start;
    cursor: pointer;
  }

  &__navigation {
    position: absolute;
    top: 120px;
    display: flex;
    justify-content: center;
    width: 40px;
    height: 40px;
    align-items: center;
    border-radius: 50%;
    background-color: #232323;
    color: #FFFFFF;
    font-size: 24px;
    cursor: pointer;
    opacity: 0;
    transition: all .3s ease-in-out;
    user-select: none;

    &--left {
      left: 8px;
    }

    &--right {
      right: 8px;
    }
  }

  &:hover &__navigation {
    opacity: 1;
  }
}
</style>
